import { render, staticRenderFns } from "./pastTimeDebtorsReport.vue?vue&type=template&id=30254671&scoped=true&"
import script from "./pastTimeDebtorsReport.vue?vue&type=script&lang=js&"
export * from "./pastTimeDebtorsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30254671",
  null
  
)

export default component.exports